module.exports = __webpack_public_path__ + "media/images/views/client/home/banner-sp-bf2b2cc13335a65c27f9747fa68c6769.png";